var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroSectionCircle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7631,
    cy: 20.2331,
    r: 20,
    transform: "rotate(-48.1489 20.7631 20.2331)",
    fill: "url(#paint0_linear_329_215)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_329_215",
    x1: 37.3148,
    y1: 7.40547,
    x2: 5.31477,
    y2: 35.8193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#298BD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15476A",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroSectionCircle2);
export default __webpack_public_path__ + "static/media/heroSectionCircle2.2ce65ea7bc8e52530a8b09a3031934e8.svg";
export { ForwardRef as ReactComponent };